module.exports = __webpack_public_path__ + "static/media/fsc.0f6cb595.png";